/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GET_ASSET_DETAIL } from "../pages/ListedAssetDetail/graphql/listed-asset-detail.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UNLIST_ASSET } from "../pages/ListedAssetDetail/graphql/unlist-asset.mutation";
import { EDIT_PRICE,EDIT_PRICE_IND , GET_ASSET_VOUCHER } from "../pages/ListedAssetDetail/graphql/edit-price.mutation";
import {SIGN_VOUCHER_MESSAGE} from "./config/list-asset-individual-data";
import {GET_RESELL_ASSET_VOUCHER} from "../pages/ListedAssetDetail/graphql/get-resell-voucher.query";
import {useAsset } from "../pages/ListedAssetDetail/provider";
import {toast} from "react-hot-toast"
import {SOUND,VIDEO ,PDF} from "../assets";
import {StorageModule} from "@vlinder-web/storage-module-react";
import { humanize } from "uno-js";
import {getErrorMessage} from "../utils/error.message";

const is = require('is_js');

const MODULE_NAME = "ListedAssetDetailService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
interface IProps{
    imageServer:any
}


export class ListedAssetDetailService {
    private static instance: ListedAssetDetailService;
    private vapp: VApplication;
    private imageServer;
    private fiatEnabled;
    private payEnabled;
    private payProvider;
    private constructor(props: IProps | any = {}) {
        this.vapp = VApplication.getInstance();
        this.imageServer = props?.imageServer;
        this.fiatEnabled = props?.fiatEnabled;
        this.payEnabled = props?.payEnabled;
        this.payProvider = props?.payProvider;
    }
    public static getInstance(props: IProps | any = {}): ListedAssetDetailService {
        if (!ListedAssetDetailService.instance) {
            ListedAssetDetailService.instance = new ListedAssetDetailService(props);
        }
        return ListedAssetDetailService.instance;
    }

    _getCheckboxes(price: any) {
        let _tempcheckboxes: any = [];
        is.array(price) && price.map((item: any) => {
            if (item?.type === 'fiat') {
                _tempcheckboxes.push({
                    id: "fiat",
                    label: "Listed in Fiat",
                    price: `${item?.amount} ${item?.currency}`,
                    status: true
                })
            }
            if (item?.type === 'crypto') {
                _tempcheckboxes.push({
                    id: "crypto",
                    label: "Listed in Crypto",
                    price: `${item?.amount} ${item?.currency}`,
                    status: true
                })
            }
        });

        return _tempcheckboxes;

    }

    _getButtons(price: any, type:string) {
        const _payment = ListedAssetDetailService.getInstance();
        const storageService = StorageModule.getInstance();
        const fiatEnabled = storageService.get("fiatEnabled", "session");
        const payProvider = storageService.get("payProvider", "session");
        console.log('payment enabled', this.payEnabled?.razorpay);
        
        let _buttons: any = [];

        if(type === "doc"){
            _buttons.push({
                key:"pdfPreview",
                title:"Preview PDF"
            })
        }

        let _types = is.array(price) && price.map((item: any) => {
            return item?.type
        });

        if (!_types.includes("fiat")) {
            if(payProvider === 'razorpay' && !_payment?.payEnabled?.razorpay){
                _buttons.push({
                        key: "listInFiat",
                        title: "List in FIAT",
                        disabled: true,
                        tooltip: "Coming Soon"
                })
            }
            else if(payProvider === 'stripe' && !_payment?.payEnabled?.stripe){
                _buttons.push({
                        key: "listInFiat",
                        title: "List in FIAT",
                        disabled: true,
                        tooltip: "Coming Soon"
                })
            }
            else if((_payment?.payEnabled?.razorpay || _payment?.payEnabled?.stripe) && !fiatEnabled){
                _buttons.push({
                        key: "listInFiat",
                        title: "List in FIAT",
                        disabled: (!fiatEnabled) ? true : false,
                        tooltip: (!fiatEnabled )? "KYC Pending, please complete it in profile" : null
                })
            }
            else if((_payment?.payEnabled?.razorpay || _payment?.payEnabled?.stripe) && fiatEnabled){
                _buttons.push({
                    key: "listInFiat",
                    title: "List in FIAT",
                    disabled: false,
            })
            }
        }
        // if (!_types.includes("fiat")) {
        //     _buttons.push(
        //         {
        //             key: "listInFiat",
        //             title: "List in FIAT",
        //             disabled: (!fiatEnabled) ? true : false,
        //             tooltip: (!fiatEnabled )? "KYC Pending, please complete it in profile" : null
        //         }
        //     )
        // }
        if (!_types.includes("crypto")) {
            _buttons.push(
                {
                    key: "listInCrypto",
                    title: "List in Crypto"
                }
            )
        }

        return _buttons;
    }

    _getActionButtons(resData: any) {
        let _actionButtons: any = [];
        if (resData.viewInIpfs) {
            _actionButtons.push({
                title: "View on Ipfs",
                link: resData?.viewInIpfs
            })
        }

        return _actionButtons;

    }

    _getImages(data: any,media:any , type:string) {

        // const getassetsDetailService = ClaimAssetDetailService.getInstance();
        const imgUrl = data?.img;
        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
        const imgBBformat = imgUrl?.split('/');
        const ibbFormat = imgBBformat[imgBBformat.length-3]
     
        let _imgF;
         if(ibbFormat === "i.ibb.co"){
            // _imgF =`${getassetsDetailService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
            _imgF = data?.img
         
         } 
         else {
            //  _imgF = `${getassetsDetailService.imageServer}${urlFormat}/:/rs=h:500`
            _imgF = data?.img
         }
         let _img;

         if(type === "audio"){
             _img = {
                original: data?.thumbnail ?? SOUND,
                thumbnail: data?.thumbnail ?? SOUND,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                type: "audio",
                 embedUrl: data?.img,
            }
         }
         if(type === "video"){
            _img = {
               original: data?.thumbnail ?? VIDEO,
               thumbnail: data?.thumbnail ?? VIDEO,
               thumbnailHeight: "70",
               thumbnailClass: "image-thumb",
               type: "video",
                embedUrl: data?.img,
           }
        }
         if(type === "image"){
            _img = {
                original: _imgF,
                thumbnail: _imgF,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            }
         }

         if(type === "doc"){
            _img = {
                // original: _imgF,
                // thumbnail: _imgF,
                original:  data?.thumbnail ?? PDF,
                thumbnail: data?.thumbnail ?? PDF,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                pdfUrl:data?.img,
                type: "doc",
            }
         }
             
       
        let _data = media?.map((item: any) => {
            console.log("insidde",item)

            const imgUrl = item?.src;
            const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
            const imgBBformat = imgUrl?.split('/');
            const ibbFormat = imgBBformat[imgBBformat.length-3]
         
            let _imgM;
             if(ibbFormat === "i.ibb.co"){
                // _imgF =`${getassetsDetailService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
                _imgF = imgUrl
             
             } 
             else {
                //  _imgM = `${getassetsDetailService.imageServer}${urlFormat}/:/rs=h:500`
                _imgF = imgUrl
             }

            //    const uriType = ele?.uri.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0]
             const assetType = item?.type?.substring(0, item?.type?.indexOf('/'))
             // const assetType;
             let selectThumbnail;
             if(assetType === "video"){
                 selectThumbnail = VIDEO
             } else if( assetType === "audio"){
                 selectThumbnail = SOUND
             }else if( assetType === "doc"){
                selectThumbnail = PDF
            } 
              else {
                 selectThumbnail = imgUrl
             }
            return {
                // ...item,
                original: selectThumbnail,
                    thumbnail: selectThumbnail,
                    thumbnailHeight: "70",
                    thumbnailClass: "image-thumb",
                    embedUrl: imgUrl,
                    type: assetType,
            };
        });
        console.log("IMG_DETAIL",[_img,..._data])

        let _images = [_img,..._data]
        return _images;

       
    }
    _getMeta(data: any[], digitalTwin: string) {
        let _meta = [];

        data?.map((item: any) => {
            _meta.push({
                key: item?.name,
                value: item?.val,
                disp_type: item?.disp_type,
            });
        });
        

        _meta.push({
            key: "Digital Twin",
            value: digitalTwin,
        });

        return _meta;
    }

    async getListedAssetDetail(assetId: string, assetGroup: string) {
        const { id,group,store} =useAsset();
        console.log("machStore",store, "group", group , "id", id)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSET_DETAIL,
                    variables: {
                        tokenId: assetId,
                        storeId:store,
                        tokenGroup:group
                    },
                    fetchPolicy: 'network-only'
                });
                if (res) {
                    let _data = res?.data?.getAsset
                    console.log("listedServiceData",_data)
                    let _found = {
                        idx: _data?.idx,
                        title: _data?.title,
                        subtitle: _data?.subtitle,
                        tokenId: _data?.serialNo,
                        serialNo: _data?.serialNo,
                        networkType: _data?.networkType,
                        tag: _data?.tag?.toUpperCase(),
                        category: _data?.tag?.toLowerCase(),
                        price: _data?.price,
                        // meta: _data?.attrs?.map((item: any) => {
                        //     return ({
                        //         key: item?.name,
                        //         value: item?.val,
                        //         disp_type: item?.disp_type
                        //     })
                        // }),
                        meta: this._getMeta(_data?.attrs, _data?.digitalTwin),
                        createdBy: {
                            userName: _data?.creator?.name,
                            userId: _data?.creator?.name,
                            // link: "/swiss-timing",
                            authProofUrl:res?.data?.viewInIpfs 
                        },
                        ownedBy:{
                            userName: _data?.owner?.name,
                            userId: _data?.owner?.name,
                        },
                        checkbox: this._getCheckboxes(_data?.price),
                        actions: this._getButtons(_data?.price,_data?.type),
                        //  info: this._getActionButtons(res?.data),
                        nftProvenance: _data?.nftProvenance?.map(item => {
                            console.log("nftprov",item)
                            return ({
                                title: item?.title,
                                profile: {
                                    // userName: item?.from?.name ?? item?.to?.name ,
                                    userName: item?.title === "Owned By" || item?.title ==="Minted By" ? item?.to?.name : item?.from?.name,
                                    fromAddress:item?.title === "Owned By" || item?.title ==="Minted By" ? item?.to?.address : item?.from?.address,
                                    link: item?.form?.link,
                                    tx_proof:item?.tx_proof,
                                    // fromAddress:item?.from?.address,
                                    // toAddress:item?.to?.address,
                                    authProofUrl: res?.data?.viewInIpfs  
                                },
                                eventOccurence: {
                                    date:item?.date
                                },
                                meta: {
                                    ...item?.meta
                                }
                            })
                        }),
                        nftSMProvenance : _data?.nftProvenance?.map((item) => {
                            return {
                                data: [
                                    {
                                        tag: item?.from?.name ?? item?.to?.name,
                                        title: item?.title,
                                        subtitle: item?.from?.name ?? item?.to?.name,
                                        link: item?.form?.link,
                                         price: item?.meta?.priceInFiat ??item?.meta?.priceInCrypto ,
                                        date: item?.date,
                                        tx_proof:item?.tx_proof,
                                        fromAddress:item?.from?.address,
                                        toAddress:item?.to?.address,
                                        authProofUrl: res?.data?.viewInIpfs 
                                    },
                                ],
                            };
                        }),
                        images: _data?.img && _data?.media ? this._getImages(_data, _data?.media, _data?.type) : [{
                            original: "https://i.ibb.co/Zg6b30B/no-image.png",
                            thumbnail: "https://i.ibb.co/Zg6b30B/no-image.png",
                            thumbnailHeight: "70",
                            thumbnailClass: "image-thumb",
                        } ],
                      
                    }
                    console.log("_found",_found)
                    if (_found) {
                        return _found;
                    }

                }
                // log.success(SERVICE_NAME, "get asset detail result: ", res);
                // // return res?.data?.getAssets;
                // return res?.data?.getAsset;
            }
        } catch (err:any) {
            getErrorMessage(err);
        }
    }

    async unlistAssetService(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `unlist asset in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: UNLIST_ASSET,
                    variables: {
                        input: data


                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "UNLIST ASSET ASSET: ", res);
                if (res) {
                    return res
                }
            }
        } catch (err:any) {
            getErrorMessage(err);
        }
    }


    
    async editPrice(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `EDIT PRICE  data in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: EDIT_PRICE,
                    variables: {
                        input: data
                    },
                    
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "EDIT PRICE: ", res);
                if (res) {
                    return res
                }
            }
        } catch (err : any) {
           getErrorMessage(err);
        }
    }

    async getVoucher(data: any, auth:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `editPrice voucher`, data);
        console.log("datavoucher",data)
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSET_VOUCHER,
                    variables: {
                        auth:{
                            signature: auth?.result?.result,
                            expected_address: auth?.result?.params[1],
                            message: SIGN_VOUCHER_MESSAGE,
                            walletName:auth?.walletName
                        },
                        input: {
                            tokenId: data?.tokenId,
                            tokenGroup: data?.tokenGroup,
                            price: data?.price,
                            type:data?.voucher
                        }
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "LIST ASSET: ", res);
                if (res?.data) {
                    return res?.data;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async getResellVoucher(data: any, auth:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `editPrice voucher`, data);
        console.log("datavoucher",data)
        try {
            if (client) {
                const res = await client.query({
                    query: GET_RESELL_ASSET_VOUCHER,
                    variables: {
                        auth:{
                            signature: auth?.result?.result,
                            expected_address: auth?.result?.params[1],
                            message: SIGN_VOUCHER_MESSAGE,
                            walletName:auth?.walletName
                        },
                        input: {
                            tokenId: data?.tokenId,
                            tokenGroup: data?.tokenGroup,
                            price: data?.price,
                            type:data?.voucher
                        }
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "LIST ASSET: ", res);
                if (res?.data) {
                    return res?.data;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }


    async sendSignedVoucher(data: any, signedobj:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `listAssetdata in service`, signedobj);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: EDIT_PRICE_IND,
                    variables: {
                        input: {
                            ...data,
                            voucher:signedobj?.value?.voucher
                        },
                        auth:{
                            signature: signedobj?.value?.auth?.result?.result,
                            expected_address: signedobj?.value?.auth?.result?.params[1],
                            message: SIGN_VOUCHER_MESSAGE, 
                            walletName: signedobj?.value?.auth?.walletName
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "LIST ASSET: ", res);
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }
}
